// extracted by mini-css-extract-plugin
export default {"row":"styles_row__yHiC0","actions":"styles_actions__2gqMz","cors":"styles_cors__Th+LR"};